module.exports = __webpack_public_path__ + "img/1470326937.449d5ab9.jpg";